import { SettingsNavigation, type SettingsNavigationItem } from '../SettingsNavigation'

const ITEMS: SettingsNavigationItem[] = [
  { id: 'settings-tab-invoice-data', label: 'Rechnungsdaten', to: '/settings/invoice' },
  {
    id: 'settings-tab-invoice-auto',
    label: 'Rechnungsautomatik',
    to: '/settings/invoice/automation',
  },
  {
    id: 'settings-tab-invoice-series',
    label: 'Rechnungsnummernserie',
    to: '/settings/invoice/numbering',
  },
  { id: 'settings-tab-invoice-texts', label: 'Rechnungstexte', to: '/settings/invoice/texts' },
]

export function InvoiceSettingsNav() {
  return <SettingsNavigation items={ITEMS} />
}
